import type {
	CreateEntitlementGroupDto,
	CreateEntitlementGroupTermDto,
	EntitlementTermsTypesEnum,
	UpdateEntitlementGroupDto,
} from '@bondsports/types';

/**
 * Mirrors `EntitlementTermsTypesEnum.EXTERNAL_VALIDATION` and the group bodies until `@bondsports/types` publishes them.
 * The types bump keys `GROUP_TYPE_MAP` (`columns.ts`) by the published member and deletes this file.
 */
export const EXTERNAL_VALIDATION_TERMS_TYPE = 'external_validation' as const;

export type EntitlementGroupType = EntitlementTermsTypesEnum | typeof EXTERNAL_VALIDATION_TERMS_TYPE;

export interface IEntitlementGroupTermBody extends Omit<CreateEntitlementGroupTermDto, 'type'> {
	type: EntitlementGroupType;
}

export interface ICreateEntitlementGroupBody extends Omit<CreateEntitlementGroupDto, 'type' | 'terms'> {
	type: EntitlementGroupType;
	terms: IEntitlementGroupTermBody[];
}

export interface IUpdateEntitlementGroupBody extends Omit<UpdateEntitlementGroupDto, 'terms'> {
	terms: IEntitlementGroupTermBody[];
}
